export default __webpack_public_path__ + "static/og_image-bd705f7671936a21d66a5ba15ef9551c.jpeg";